import { createFileRoute } from '@tanstack/react-router'

import { DocumentUploadPage } from '@/components/organisms/document-upload/document-upload-page'

const DocumentsUploadRoute = () => {
  // `errandId` is still accepted here so links created before /errands/$id/upload existed keep
  // attaching their document to the right errand. New errand uploads go to that route instead,
  // which is what keeps the sidebar and breadcrumb on Ärenden.
  const { errandId } = Route.useSearch()

  return <DocumentUploadPage errandId={errandId} />
}

export const Route = createFileRoute('/_authenticated/documents/upload')({
  component: DocumentsUploadRoute,
  validateSearch: (search: Record<string, unknown>) => ({
    errandId: typeof search.errandId === 'string' ? search.errandId : undefined,
  }),
})
